// ------------------------------------4
// 控制小元件的生成或隱藏
// props 輸入需求 :
// props.OnOff_switch : array                                       ( 傳入各元件是否開啟 [true, false, ...] )
// props.date : obj ( obj new Date)() )                             ( 傳入當天日期 )
// props.setReturnShift : function( params : str )                  ( 回傳 : str ('morn', 'mid', 'night') )
// props.setReturnState : function( params : str )                  ( 回傳 : str ('level 1', 'level 2', 'level 3') )
// props.type : str                                                 ( 'bed', 'name' )
// props.data : str                                                 ( 根據 type 放名或床 )
// ------------------------------------

import React, { useState } from 'react';
import Account from '../../../../actions/Account';
import AlertState from './AlertState';
import BEDandName from './BEDandNAME';
import DateCalander from './DateCalander';
import ThreeShift from './ThreeShift';
import { useTranslation } from 'react-i18next';
import FordaysSwitch from './FordaysSwitch';
import DayToNight from './DayToNight';

const UiIntegrater = (props) => {
  const { t } = useTranslation();
  const { days_open, setDays_open, daySwitch, setDaySwitch, page } = props;
  return (
    <div className={`${Account.isMobile() ? 'pad-15 l r' : ''} h-10 fx-d-r font-ml fx-aic`}>
      <div className={`fx-d-r col-6`} style={{ justifyContent: 'flex-start' }}>
        <DateCalander date={props.date} isON={props.OnOff_switch[0]} />

        {props.fordays && (
          <>
            <FordaysSwitch days_open={days_open} setDays_open={setDays_open} />
            {days_open === 'FORDAYS' && page === 'dayChart' && <DayToNight setDaySwitch={setDaySwitch} daySwitch={daySwitch} />}
          </>
        )}
        {Account.isMobile() ? null : (
          <>
            <ThreeShift setReturnShift={props.setReturnShift} isON={props.OnOff_switch[1]} />
            <AlertState setReturnState={props.setReturnState} isON={props.OnOff_switch[2]} />
          </>
        )}
      </div>
      {/* <div className={`${Account.isMobile() ? 'littleUi' : 'col-2'}`}></div> */}
      <div className="fx-d-r col-4">
        <BEDandName data={props.bed} type={'bed'} isON={props.OnOff_switch[3]} />
        <BEDandName data={props.name} type={'name'} isON={props.OnOff_switch[4]} />
      </div>
    </div>
  );
};
export default UiIntegrater;
